export default {
  placeholder: 'Wybierz tagi',
  tagPlaceholder: 'Dodaj nowy tag',
};
